import { heapEvent } from '@equipmentshare/heaper'
import AdjustQuantity from '../AdjustQuantity'

export default function getAdjustQuantityModal( storePartId: number, onSuccess?: () => void ) {
	return {
		component: AdjustQuantity,
		componentProps: { storePartId },
		label: 'Adjust Quantity',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Adjust Quantity Modal - Click -X button', {} ),
		width: '700px',
	}
}
